import { render, staticRenderFns } from "./DownloadFiles.vue?vue&type=template&id=bcc839ca&scoped=true"
import script from "./DownloadFiles.vue?vue&type=script&lang=js"
export * from "./DownloadFiles.vue?vue&type=script&lang=js"
import style0 from "./DownloadFiles.vue?vue&type=style&index=0&id=bcc839ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc839ca",
  null
  
)

export default component.exports